<template>
  <div id="app">
    <Header/>
    <router-view></router-view>
  </div>
</template>

<script>
//import { Actions } from '@/store/stateChanges'
import Header from "@/components/Header";

export default {
  name: 'app',
  components: {
    Header
  },
  data() {
    return {
    }
  },
  mounted() {
    if (this.$route.query.search) {
      if (this.$route.name !== 'Results') {
        this.$router.push({ path: '/results', query: { search: this.$route.query.search }})
      }
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search)
    const lang = urlParams.get('lang')
    if (this.$cookies.get('DICTA_USE_HEBREW') !== null) {
      this.$settings.hebrew = (this.$cookies.get('DICTA_USE_HEBREW') === 'true')
    } else if (lang !== null) {
      this.$settings.hebrew = lang.includes('he')
    } else {
      this.$settings.hebrew = true
    }
    if (this.$settings.hebrew) {
      document.body.classList.add('he')
    } else {
      document.body.classList.remove('he')
    }
  },
  computed: {
    hebrew() {
      return this.$settings.hebrew
    }
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'mft_narkisclassic';
  src: url('assets/fonts/mft_narkisclassic-regular.woff') format('woff');
  font-style: normal;
  font-weight: normal;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'mft_narkisclassic';
  src: url('assets/fonts/MFTW_NarkisClassicBold.woff') format('woff');
  font-style: normal;
  font-weight: bold;
}

a {
  cursor: pointer;
}

.f-narkis {
  font-family: Roboto, mft_narkisclassic, sans-serif;
  line-height: 1.5;
}

.rounded-top {
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
}

.rounded-bottom {
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.centered {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dicta-dropdown .dropdown-item {
  text-align: left;
}

.he .dicta-dropdown .dropdown-item {
  text-align: right;
}

.modal-footer {
  direction: ltr;
}

.he .modal-footer {
  direction: rtl;
}

.search-link {
  line-height: 28px;
  margin-top: 3px;

  &:hover {
    text-decoration: none;
    background: var(--secondary);
  }
}
</style>

<style lang="scss" scoped>
.main-content {
  flex: auto;
  min-height: 500px;
}
</style>
